export default {
    palette: {
        primary: {
            main: '#353740'
        },
        secondary: {
            main: '#98c5e9'
        }
    },
    typography: {
        fontFamily: 'Montserrat,Helvetica,Arial,Lucida,sans-serif !important',
        h4: {
            fontFamily:
                'Montserrat,Helvetica,Arial,Lucida,sans-serif !important',
            textTransform: 'uppercase',
            fontWeight: 500
        },
        h5: {
            fontFamily:
                'Montserrat,Helvetica,Arial,Lucida,sans-serif !important',
            textTransform: 'uppercase'
        }
    }
};
